const Event = () => import('@/views/Event')
const CreateEvent = () => import('@/views/Event/createEvent')
const SelectPolicy = () => import('@/views/Event/selectPolicy')
const SelectMaterial = () => import('@/views/Event/selectMaterial')
const EventDetail = () => import('@/views/Event/detail')
const SellOutAdd = () => import('@/views/Event/sellOutAdd')
const EventRecord = () => import('@/views/Event/eventRecord')
const eventRouter = [
  {
    path: '/event',
    component: Event,
    meta: {
      title: 'Event'
    }
  },
  {
    path: '/createEvent',
    component: CreateEvent,
    meta: {
      title: 'Create Event'
    }
  },
  {
    path: '/selectPolicy',
    component: SelectPolicy,
    meta: {
      title: 'Select a Policy'
    }
  },
  {
    path: '/selectMaterial',
    component: SelectMaterial,
    meta: {
      title: 'Material Delivery'
    }
  },
  {
    path: '/eventDetail',
    component: EventDetail,
    meta: {
      title: 'Event Detail'
    }
  },
  {
    path: '/sellOutAdd',
    component: SellOutAdd,
    meta: {
      title: 'Sell-out'
    }
  },
  {
    path: '/eventRecord',
    component: EventRecord,
    meta: {
      title: 'Event Record'
    }
  }
]

export default eventRouter
